/**
 * AcademicTransfer E-Learning Quiz Data
 * Complete quizzes and reflection questions based on the proposal
 */

const QUIZ_DATA = {
  // =====================================================
  // MODULE 1 QUIZZES
  // =====================================================

  'quiz-intro': {
    id: 'quiz-intro',
    type: 'single-choice',
    questionKey: 'quizzes.intro.question',
    explanationKey: 'quizzes.intro.explanation',
    options: [
      { id: 'a', textKey: 'quizzes.intro.optionA', correct: true },
      { id: 'b', textKey: 'quizzes.intro.optionB', correct: false },
      { id: 'c', textKey: 'quizzes.intro.optionC', correct: false },
      { id: 'd', textKey: 'quizzes.intro.optionD', correct: false }
    ]
  },

  'quiz-account': {
    id: 'quiz-account',
    type: 'reflection',
    questionKey: 'quizzes.account.question',
    explanationKey: 'quizzes.account.explanation',
    promptKey: 'quizzes.account.prompt'
  },

  'quiz-navigator': {
    id: 'quiz-navigator',
    type: 'scenario',
    questionKey: 'quizzes.navigator.question',
    explanationKey: 'quizzes.navigator.explanation',
    options: [
      { id: 'a', textKey: 'quizzes.navigator.optionA', correct: false },
      { id: 'b', textKey: 'quizzes.navigator.optionB', correct: true },
      { id: 'c', textKey: 'quizzes.navigator.optionC', correct: false },
      { id: 'd', textKey: 'quizzes.navigator.optionD', correct: false }
    ]
  },

  // =====================================================
  // MODULE 2 QUIZZES
  // =====================================================

  'quiz-competence': {
    id: 'quiz-competence',
    type: 'drag-drop',
    questionKey: 'quizzes.competence.question',
    explanationKey: 'quizzes.competence.explanation',
    items: [
      {
        id: 'research',
        textKey: 'quizzes.competence.item1',
        matchKey: 'quizzes.competence.match1'
      },
      {
        id: 'personal',
        textKey: 'quizzes.competence.item2',
        matchKey: 'quizzes.competence.match2'
      },
      {
        id: 'professional',
        textKey: 'quizzes.competence.item3',
        matchKey: 'quizzes.competence.match3'
      },
      {
        id: 'leadership',
        textKey: 'quizzes.competence.item4',
        matchKey: 'quizzes.competence.match4'
      },
      {
        id: 'communication',
        textKey: 'quizzes.competence.item5',
        matchKey: 'quizzes.competence.match5'
      },
      { id: 'teaching', textKey: 'quizzes.competence.item6', matchKey: 'quizzes.competence.match6' }
    ]
  },

  'quiz-reflector': {
    id: 'quiz-reflector',
    type: 'scenario',
    questionKey: 'quizzes.reflector.question',
    explanationKey: 'quizzes.reflector.explanation',
    options: [
      { id: 'a', textKey: 'quizzes.reflector.optionA', correct: false },
      { id: 'b', textKey: 'quizzes.reflector.optionB', correct: false },
      { id: 'c', textKey: 'quizzes.reflector.optionC', correct: true },
      { id: 'd', textKey: 'quizzes.reflector.optionD', correct: false }
    ]
  },

  // =====================================================
  // MODULE 3 QUIZZES
  // =====================================================

  'quiz-cv': {
    id: 'quiz-cv',
    type: 'multi-choice',
    questionKey: 'quizzes.cv.question',
    explanationKey: 'quizzes.cv.explanation',
    options: [
      { id: 'a', textKey: 'quizzes.cv.optionA', correct: true },
      { id: 'b', textKey: 'quizzes.cv.optionB', correct: true },
      { id: 'c', textKey: 'quizzes.cv.optionC', correct: false },
      { id: 'd', textKey: 'quizzes.cv.optionD', correct: true }
    ]
  },

  'quiz-research': {
    id: 'quiz-research',
    type: 'single-choice',
    questionKey: 'quizzes.research.question',
    explanationKey: 'quizzes.research.explanation',
    options: [
      { id: 'a', textKey: 'quizzes.research.optionA', correct: false },
      { id: 'b', textKey: 'quizzes.research.optionB', correct: false },
      { id: 'c', textKey: 'quizzes.research.optionC', correct: true },
      { id: 'd', textKey: 'quizzes.research.optionD', correct: false }
    ]
  },

  'quiz-network': {
    id: 'quiz-network',
    type: 'scenario',
    questionKey: 'quizzes.network.question',
    explanationKey: 'quizzes.network.explanation',
    options: [
      { id: 'a', textKey: 'quizzes.network.optionA', correct: false },
      { id: 'b', textKey: 'quizzes.network.optionB', correct: true },
      { id: 'c', textKey: 'quizzes.network.optionC', correct: false },
      { id: 'd', textKey: 'quizzes.network.optionD', correct: false }
    ]
  },

  // =====================================================
  // REFLECTION QUESTIONS (After completing tools)
  // =====================================================

  'reflection-competence': {
    id: 'reflection-competence',
    type: 'reflection-popup',
    titleKey: 'reflections.competence.title',
    questionKey: 'reflections.competence.question',
    promptKey: 'reflections.competence.prompt',
    fields: [
      { id: 'top3', labelKey: 'reflections.competence.field1', type: 'textarea' },
      { id: 'improve', labelKey: 'reflections.competence.field2', type: 'textarea' }
    ]
  },

  'reflection-pitch': {
    id: 'reflection-pitch',
    type: 'reflection-popup',
    titleKey: 'reflections.pitch.title',
    questionKey: 'reflections.pitch.question',
    promptKey: 'reflections.pitch.prompt'
  }
};

// Helper Functions
function getQuizById(quizId) {
  return QUIZ_DATA[quizId] || null;
}

function checkAnswer(quizId, answerId) {
  const quiz = getQuizById(quizId);
  if (!quiz || !quiz.options) {
    return null;
  }

  const option = quiz.options.find((o) => o.id === answerId);
  return option ? option.correct : false;
}

function getCorrectAnswers(quizId) {
  const quiz = getQuizById(quizId);
  if (!quiz || !quiz.options) {
    return [];
  }

  return quiz.options.filter((o) => o.correct).map((o) => o.id);
}

function checkMultiAnswer(quizId, selectedIds) {
  const correctIds = getCorrectAnswers(quizId);
  if (correctIds.length !== selectedIds.length) {
    return false;
  }
  return correctIds.every((id) => selectedIds.includes(id));
}

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { QUIZ_DATA, getQuizById, checkAnswer, getCorrectAnswers, checkMultiAnswer };
}
